module.exports = __webpack_public_path__ + "img/content-1.eb697d77.png";